import { render } from "./all_student.vue?vue&type=template&id=56a64651&scoped=true"
import script from "./all_student.vue?vue&type=script&lang=js"
export * from "./all_student.vue?vue&type=script&lang=js"

import "./all_student.vue?vue&type=style&index=0&id=56a64651&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a64651"]])

export default __exports__